import { SVGProps, Ref, forwardRef } from 'react';

export const FlagFilledSize24Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={24} height={24} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <g>
            <path
                d="M2 2.134c4.5-1.964 7.25-.982 10 0 2.363.844 4.726 1.688 8.2.662q.572-.168 1.188-.408L22 3v14.866c-4.5 1.964-7.25.982-10 0-2.363-.844-4.726-1.688-8.2-.662V23H2z"
                fill="currentColor"
            />
        </g>
    </svg>
));
FlagFilledSize24Glyph.displayName = 'FlagFilledSize24Glyph';
